module.exports = __webpack_public_path__ + "static/media/btg_celular_02.1776c6ab.png";